import React from "react";

export const Logo: React.FC = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 463 138" fill="none">
      <g id="Bazzy_1_bily">
        <g>
          <path
            id="Ellipse 1"
            d="M111.748 68.958C111.748 92.546 92.6263 111.668 69.0383 111.668C45.4502 111.668 26.3283 92.546 26.3283 68.958C26.3283 45.3699 45.4502 26.248 69.0383 26.248C92.6263 26.248 111.748 45.3699 111.748 68.958Z"
            stroke="white"
            strokeWidth="7"
          ></path>
          <path
            id="Ellipse 2"
            d="M94.8618 68.9581C94.8618 80.8376 91.7251 91.4308 86.8387 98.9478C81.9306 106.498 75.5597 110.568 69.0383 110.568C62.5168 110.568 56.1459 106.498 51.2379 98.9478C46.3514 91.4308 43.2147 80.8376 43.2147 68.9581C43.2147 57.0786 46.3514 46.4855 51.2379 38.9685C56.1459 31.4183 62.5168 27.3486 69.0383 27.3486C75.5597 27.3486 81.9306 31.4183 86.8387 38.9685C91.7251 46.4855 94.8618 57.0786 94.8618 68.9581Z"
            stroke="white"
            strokeWidth="7"
          ></path>
          <line
            id="Line 1"
            x1="69.1343"
            y1="23.8486"
            x2="69.1343"
            y2="114.068"
            stroke="white"
            strokeWidth="7"
          ></line>
          <line
            id="Line 2"
            x1="28.1587"
            y1="52.501"
            x2="110.642"
            y2="52.2778"
            stroke="white"
            strokeWidth="7"
          ></line>
          <line
            id="Line 3"
            x1="26.7621"
            y1="82.963"
            x2="111.271"
            y2="82.4426"
            stroke="white"
            strokeWidth="7"
          ></line>
        </g>

        <g id="logo">
          <g id="logo_velke">
            <rect
              id="Rectangle 2"
              x="62.5026"
              y="0.385742"
              width="13.8145"
              height="13.8145"
              rx="2"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 13"
              x="98.6879"
              y="6.42969"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(30 98.6879 6.42969)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 12"
              x="137.982"
              y="62.0508"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(90 137.982 62.0508)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 11"
              x="0.837708"
              y="62.0508"
              width="13.8145"
              height="13.8145"
              rx="2"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 10"
              x="62.5026"
              y="123.716"
              width="13.8145"
              height="13.8145"
              rx="2"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 9"
              x="39.7147"
              y="6.42969"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(60 39.7147 6.42969)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 8"
              x="121.268"
              y="88.9834"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(30 121.268 88.9834)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 7"
              x="17.5236"
              y="88.9834"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(60 17.5236 88.9834)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 6"
              x="35.0759"
              y="112.616"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(30 35.0759 112.616)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 5"
              x="103.744"
              y="112.616"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(60 103.744 112.616)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 4"
              x="12.4672"
              y="30.0615"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(30 12.4672 30.0615)"
              fill="white"
            ></rect>
            <rect
              id="Rectangle 3"
              x="126.324"
              y="30.0615"
              width="13.8145"
              height="13.8145"
              rx="2"
              transform="rotate(60 126.324 30.0615)"
              fill="white"
            ></rect>
          </g>

          <g id="logo_male">
            <rect
              id="Rectangle 14"
              x="64.5837"
              y="2.4668"
              width="9.65222"
              height="9.65222"
              rx="1"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 25"
              x="126.249"
              y="64.1318"
              width="9.65222"
              height="9.65222"
              rx="1"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 24"
              x="99.4496"
              y="9.27246"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(30 99.4496 9.27246)"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 23"
              x="102.983"
              y="115.459"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(60 102.983 115.459)"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 22"
              x="64.5837"
              y="125.797"
              width="9.65222"
              height="9.65222"
              rx="1"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 21"
              x="122.029"
              y="91.8262"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(30 122.029 91.8262)"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 20"
              x="2.91888"
              y="64.1318"
              width="9.65222"
              height="9.65222"
              rx="1"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 19"
              x="35.8376"
              y="115.356"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(30 35.8376 115.356)"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 18"
              x="13.2289"
              y="32.9043"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(30 13.2289 32.9043)"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 17"
              x="16.7618"
              y="91.8262"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(60 16.7618 91.8262)"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 16"
              x="38.9529"
              y="9.27246"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(60 38.9529 9.27246)"
              fill="#5E72E4"
            ></rect>
            <rect
              id="Rectangle 15"
              x="125.562"
              y="32.9043"
              width="9.65222"
              height="9.65222"
              rx="1"
              transform="rotate(60 125.562 32.9043)"
              fill="#5E72E4"
            ></rect>
          </g>
        </g>

        <path
          id="Bazzy"
          d="M159.674 37.4102H181.002C190.721 37.4102 197.768 38.8008 202.143 41.582C206.549 44.332 208.752 48.7227 208.752 54.7539C208.752 58.8477 207.783 62.207 205.846 64.832C203.94 67.457 201.393 69.0352 198.205 69.5664V70.0352C202.549 71.0039 205.674 72.8164 207.58 75.4727C209.518 78.1289 210.487 81.6602 210.487 86.0664C210.487 92.3164 208.221 97.1914 203.69 100.691C199.19 104.191 193.065 105.941 185.315 105.941H159.674V37.4102ZM174.205 64.5508H182.643C186.58 64.5508 189.424 63.9414 191.174 62.7227C192.955 61.5039 193.846 59.4883 193.846 56.6758C193.846 54.0508 192.877 52.1758 190.94 51.0508C189.033 49.8945 186.002 49.3164 181.846 49.3164H174.205V64.5508ZM174.205 76.082V93.9414H183.674C187.674 93.9414 190.627 93.1758 192.533 91.6445C194.44 90.1133 195.393 87.7695 195.393 84.6133C195.393 78.9258 191.33 76.082 183.205 76.082H174.205ZM256.33 105.941L253.565 98.8164H253.19C250.783 101.848 248.299 103.957 245.737 105.145C243.205 106.301 239.893 106.879 235.799 106.879C230.768 106.879 226.799 105.441 223.893 102.566C221.018 99.6914 219.58 95.5977 219.58 90.2852C219.58 84.7227 221.518 80.6289 225.393 78.0039C229.299 75.3477 235.174 73.8789 243.018 73.5977L252.112 73.3164V71.0195C252.112 65.707 249.393 63.0508 243.955 63.0508C239.768 63.0508 234.846 64.3164 229.19 66.8477L224.455 57.1914C230.487 54.0352 237.174 52.457 244.518 52.457C251.549 52.457 256.94 53.9883 260.69 57.0508C264.44 60.1133 266.315 64.7695 266.315 71.0195V105.941H256.33ZM252.112 81.6602L246.58 81.8477C242.424 81.9727 239.33 82.7227 237.299 84.0977C235.268 85.4727 234.252 87.5664 234.252 90.3789C234.252 94.4102 236.565 96.4258 241.19 96.4258C244.502 96.4258 247.143 95.4727 249.112 93.5664C251.112 91.6602 252.112 89.1289 252.112 85.9727V81.6602ZM317.549 105.941H276.158V97.5039L300.44 64.457H277.612V53.5352H316.705V62.8164L293.08 95.0195H317.549V105.941ZM364.424 105.941H323.033V97.5039L347.315 64.457H324.487V53.5352H363.58V62.8164L339.955 95.0195H364.424V105.941ZM367.33 53.5352H382.987L392.877 83.0195C393.721 85.582 394.299 88.6133 394.612 92.1133H394.893C395.237 88.8945 395.908 85.8633 396.908 83.0195L406.612 53.5352H421.94L399.768 112.645C397.737 118.113 394.83 122.207 391.049 124.926C387.299 127.645 382.908 129.004 377.877 129.004C375.408 129.004 372.987 128.738 370.612 128.207V116.863C372.33 117.27 374.205 117.473 376.237 117.473C378.768 117.473 380.971 116.691 382.846 115.129C384.752 113.598 386.237 111.27 387.299 108.145L388.143 105.566L367.33 53.5352Z"
          fill="white"
        ></path>
      </g>
    </svg>
  );
};
